<template>
  <a-modal
    :visible="visible"
    :maskClosable="false"
    :closable="false"
    :keyboard="false"
    :footer="null"
    centered
    class="pip-modal"
  >
    <div class="pip-header">
      <div class="pip-icon">
        <a-icon type="safety-certificate" />
      </div>
      <div class="pip-title">个人信息保护提醒</div>
    </div>

    <div class="pip-body">
      <div class="pip-text">
        欢迎使用我们的网站服务！在您开始使用前，请您务必审慎阅读并充分理解
        <a href="#" @click.prevent="openPolicy">《隐私政策》</a>
        （版本号：{{ policyVersion }}）。
      </div>
      <div class="pip-text pip-text-secondary">我们非常重视您的个人信息保护。为了向您提供基本服务，我们需要收集您的必要个人信息。如果您点击“拒绝”，我们将为您提供“游客模式”，在此模式下我们不会收集您的个人信息，但部分功能可能无法使用。
      </div>

      <div class="pip-points">
        <div class="pip-points-title">本次收集的信息包括：</div>
        <ul>
          <li>您主动填写：姓名、邮箱、手机号、公司名称</li>
          <li>系统自动收集：IP地址、设备信息、浏览记录</li>
        </ul>
      </div>
    </div>

    <div class="pip-actions">
      <a-button class="pip-btn" @click="reject">拒绝并进入游客模式</a-button>
      <a-button class="pip-btn" type="primary" @click="accept">同意并继续</a-button>
    </div>
  </a-modal>
</template>

<script>
import { getCookie, setCookie } from "@/utils/cookie";

const CONSENT_COOKIE = "lj_pip_consent";

export default {
  name: "PersonalInfoProtectionNotice",
  props: {
    policyHref: {
      type: String,
      default: "/privacy-policy.html",
    },
    policyVersion: {
      type: String,
      default: "v1.0.0",
    },
    cookieDays: {
      type: Number,
      default: 180,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    this.syncVisibility();
    if (typeof window !== "undefined") {
      window.addEventListener("lj:pip:trigger", this.syncVisibility, {
        passive: true,
      });
    }
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("lj:pip:trigger", this.syncVisibility);
    }
  },
  methods: {
    openPolicy() {
      if (typeof window === "undefined") return;
      // 强制打开静态HTML，避免 hash 路由拼接污染 URL
      const url = `${window.location.origin}/privacy-policy.html`;

      // 用模拟点击方式，避免 window.open 被拦截或出现地址串联
      const a = document.createElement("a");
      a.href = url;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    hasDecision() {
      const v = getCookie(CONSENT_COOKIE);
      return v === "1" || v === "0";
    },
    syncVisibility() {
      if (this.hasDecision()) {
        this.visible = false;
        return;
      }
      this.visible = true;
    },
    accept() {
      setCookie(CONSENT_COOKIE, "1", { days: this.cookieDays });
      this.visible = false;
    },
    reject() {
      setCookie(CONSENT_COOKIE, "0", { days: this.cookieDays });
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.pip-modal {
  /deep/ .ant-modal-content {
    border-radius: 10px;
    overflow: hidden;
  }
  /deep/ .ant-modal-body {
    padding: 18px 20px 16px;
  }
}

.pip-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.pip-icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #e6f7ff;
  color: #1890ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pip-title {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}

.pip-body {
  color: #374151;
  font-size: 13px;
  line-height: 1.7;
}

.pip-text {
  margin-bottom: 8px;
}

.pip-text a {
  color: #1677ff;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}
.pip-text a:hover {
  color: #0958d9;
}

.pip-text-secondary {
  color: #6b7280;
}

.pip-points {
  background: #f5f7fb;
  border: 1px solid #eef2f7;
  border-radius: 10px;
  padding: 12px 12px 10px;
  margin-top: 10px;
}

.pip-points-title {
  font-weight: 600;
  margin-bottom: 6px;
  color: #111827;
}

.pip-points ul {
  padding-left: 18px;
  margin: 0;
}

.pip-actions {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 14px;
}

.pip-btn {
  flex: 1;
  height: 36px;
  border-radius: 8px;
}
</style>

